import settings from '@/settings'

const gerenciar = (headers, data, method, id) => {
  // métodos suportados POST, GET, PUT, PATCH, DELETE
  let url = `${settings.apetrusApi}/firebases/${id ? `${id}/` : ''}`
  const request = {
    method: method,
    mode: 'cors',
    headers: headers
  }
  if (method === 'GET') {
    request.cache = 'default'
    if (data) {
      Object.keys(data).forEach((filter) => {
        url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
      })
    }
  } else request.body = JSON.stringify(data)
  return fetch(url, request)
}

export default {
  gerenciar
}
